import { useContext, useEffect, useRef, useState } from "react";
import "./Ecommerce.scss";
import { EcommerceSearchSubHeader } from "../../order_entry/EcommerceSearchSubHeader/EcommerceSearchSubHeader";
import INotification from "../../../models/INotification";
import ICategory from "../../../models/ICategory";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetCategoriesDTO from "../../../models/DTO/IOnGetCategoriesDTO";
import IOnGetCategoryCatalogItemsDTO from "../../../models/DTO/IOnGetCategoryCatalogItemsDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IGetCategoriesDTO from "../../../models/DTO/IGetCategoriesDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import IGetCategoryCatalogItemsDTO from "../../../models/DTO/IGetCategoryCatalogItemsDTO";
import ICatalog_Item from "../../../models/ICatalog_Item";
import EcommerceListView from "../../order_entry/EcommerceListView/EcommerceListView";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import IOrder from "../../../models/IOrder";
import styled from "styled-components";
import IDraftOrderItem from "../../../models/IDraftOrderItem";
import IAddItemToCartDTO from "../../../models/DTO/IAddItemToCartDTO";
import IOnAddItemToCartDTO from "../../../models/DTO/IOnAddItemToCartDTO";
import { EcommerceCart } from "../EcommerceCart/EcommerceCart";
import { EcommerceRightSideHeader } from "../EcommerceRightSideHeader/EcommerceRightSideHeader";
import { useMatch, useNavigate, useSearchParams } from "react-router-dom";
import { EcommerceCategorySidebar } from "../../order_entry/EcommerceCategorySidebar/EcommerceCategorySidebar";
import { LoginMessage } from "../../dashboard/LoginMessage/LoginMessage";
import { EcommerceItemDetailPage } from "../EcommerceItemDetailPage/EcommerceItemDetailPage";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import CategoryContext from "../../../contexts/CategoryContext";
import { EcommerceHomeCategoryListView } from "../EcommerceHomeCategoryListView/EcommerceHomeCategoryListView";
import { useEcommerceLogic } from "@hooks/ecommerce/useEcommerceLogic";
import { useCart } from "@contexts/CartContext";
import ICart_Item from "@models/ICart_Item";
import { EcommerceListViewSkeleton } from "../EcommerceListViewSkeleton/EcommerceListViewSkeleton";
import { EcommerceNoResults } from "../EcommerceNoResults/EcommerceNoResults";
import { MobileCartNotification } from "../MobileCartNotification/MobileCartNotification";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { OwP } from "@components/shared/OwP/OwP";
import OwButton from "@components/shared/OwButton/OwButton";
import { DuplicateItemModal, DuplicateItemAction } from "@components/order_entry/DuplicateItemModal/DuplicateItemModal";
import OrderEntryService from "@services/OrderEntryService";
import IUpdateCartItemDTO from "@models/DTO/IUpdateCartItemDTO";
import IOnUpdateCartItemDTO from "@models/DTO/IOnUpdateCartItemDTO";
import EcommerceViewModeEnum from "@models/EcommerceViewModeEnum";
import ITokenSettingsUI from "@models/ITokenSettingsUI";
import EcommerceQuickOrder from "../EcommerceQuickOrder/EcommerceQuickOrder";
import EcommerceViewToggle from "../EcommerceViewToggle/EcommerceViewToggle";
import UserService from "@services/UserService";
import TokenService from "@services/TokenService";
import { buildVirtualRootCategories } from "@models/VirtualCategoriesUI";
import { EcommerceServiceLevels } from "../EcommerceServiceLevels/EcommerceServiceLevels";
import { EcommerceFacetSidebar } from "../EcommerceFacetSidebar/EcommerceFacetSidebar";
import FacetFilterService, { SelectedAttributeFilters } from "@services/FacetFilterService";
import ICatalogItemFacet from "@models/ICatalogItemFacet";
import IPriceRangeFilter from "@models/IPriceRangeFilter";
import IGetCatalogItemFacetsDTO from "@models/DTO/IGetCatalogItemFacetsDTO";
import IOnGetCatalogItemFacetsDTO from "@models/DTO/IOnGetCatalogItemFacetsDTO";
import { FormattedMessage } from "react-intl";

type Props = {};

export const Ecommerce: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    // Logged-in vendor's SUPPLIER_VENDOR token (price_discount_one/two) for price calculation.
    const supplierVendorToken = UserService.getSupplierVendorToken(vendorModel, supplierModel.id);
    const hidePricing = UserService.hidePricing(supplierModel, userModel, vendorModel);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);
    const categoryContext = useContext(CategoryContext);
    const { cart, refreshCart, updateCartItem } = useCart();

    const match = useMatch("/ecomm/:itemName");

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const categoryGuidFromUrl = searchParams.get("category");
    const searchTermFromUrl = searchParams.get("search");

    const { showHomeCategories } = useEcommerceLogic();

    const hasValidAccountSetup = !!(vendorModel.Catalog && vendorModel.Price_Group);

    const [homeCategories, setHomeCategories] = useState<ICategory[]>([]);
    const [categories, setCategories] = useState<ICategory[]>([]);
    const [enteredSearchTerm, setEnteredSearchTerm] = useState<string>(searchTermFromUrl || "");
    const [limit, setLimit] = useState<number>(20);
    const [offset, setOffset] = useState<number>(0);
    // Lets a category change reset the offset without the offset effect firing a duplicate fetch
    const skipNextOffsetFetchRef = useRef(false);
    const [rootCategories, setRootCategories] = useState<ICategory[] | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isCommonItems, setIsCommonItems] = useState(true);
    const [searchItems, setSearchItems] = useState<ICatalog_Item[]>([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [performedInitialSearch, setPerformInitialSearch] = useState(false);
    const [selectedCategoryGuid, setSelectedCategoryGuid] = useState<string | undefined>();
    const [cartOpen, setCartOpen] = useState(false);
    const [retrievedCategories, setRetrievedCategories] = useState(false);
    const [selectedCategoryDetail, setSelectedCategoryDetail] = useState<{ name?: string; guid?: string }>({
        guid: categoryGuidFromUrl || undefined,
    });
    const [selectedItem, setSelectedItem] = useState<ICatalog_Item | null>(null);
    const [isCategoryLoading, setIsCategoryLoading] = useState(false);
    const [selectedAttributeFilters, setSelectedAttributeFilters] = useState<SelectedAttributeFilters>(
        FacetFilterService.parseFacetsFromUrl(searchParams.get("attrs"))
    );
    const [selectedPriceRange, setSelectedPriceRange] = useState<IPriceRangeFilter | null>(
        FacetFilterService.parsePriceRangeFromParams(searchParams)
    );
    const [facets, setFacets] = useState<ICatalogItemFacet[]>([]);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    // Monotonic token echoed through the facet socket round-trip so late responses are dropped
    const facetStateRef = useRef(0);
    const [clearSearchTerm, setClearSearchTerm] = useState(0);
    const [showMobileCartNotification, setShowMobileCartNotification] = useState(false);
    const [mobileCartItem, setMobileCartItem] = useState<ICart_Item | null>(null);

    // Vendors locked to their default template items don't browse the catalog — no facets for them
    // (mirrors the EcommerceSearchSubHeader hideCatalogBrowsing gate).
    const isTemplateRestricted =
        !userModel.isSupplierUser &&
        !!vendorModel?.is_ecomm_user &&
        !!vendorModel?.ecomm_template_items_only &&
        !!supplierModel.has_templates;

    const priceRangeActive = FacetFilterService.hasActivePriceRange(selectedPriceRange);
    // Includes the price range: any active filter routes category browse through the typeahead,
    // the only item path that filters.
    const filtersActive = FacetFilterService.hasActiveFilters(selectedAttributeFilters) || priceRangeActive;
    const activeFilterCount = FacetFilterService.activeFilterCount(selectedAttributeFilters) + (priceRangeActive ? 1 : 0);
    // The price range section renders regardless of attribute facets, so the sidebar shows for
    // every selected category (except template-restricted vendors, who don't browse the catalog).
    const showFacetSidebar = !!selectedCategoryDetail.guid && !isTemplateRestricted;

    const currentToken = UserService.getCurrentToken(userModel);
    // ecomm_view_mode is a UI-owned setting (see ITokenSettingsUI) — the synced ITokenSettings doesn't declare it.
    const tokenSettings = currentToken?.settings as ITokenSettingsUI | null | undefined;
    const [viewMode, setViewMode] = useState<EcommerceViewModeEnum>(tokenSettings?.ecomm_view_mode ?? EcommerceViewModeEnum.CARD);
    const lastAppliedViewMode = useRef<EcommerceViewModeEnum | undefined>(tokenSettings?.ecomm_view_mode);

    const getItemViewClass = (): string => {
        switch (viewMode) {
            case EcommerceViewModeEnum.LIST:
                return "ecomm-list";
            case EcommerceViewModeEnum.CARD:
            default:
                return "ecomm-grid";
        }
    };

    const handleViewModeChange = (mode: EcommerceViewModeEnum) => {
        setViewMode(mode);

        // Persist the preference for the user (non-fatal if it fails — the view still updates locally).
        // Vendor (non-supplier) users require vendorModel so the request carries a vendorGuid header.
        if (currentToken) {
            TokenService.updateTokenSettings(
                currentToken.guid,
                { ecomm_view_mode: mode },
                userModel,
                supplierModel,
                userModel.isSupplierUser ? undefined : vendorModel
            ).catch((err) => {
                console.error("Failed to persist ecommerce view mode:", err);
            });
        } else {
            console.warn("Cannot persist ecommerce view mode: no current token for user.");
        }
    };

    // Apply the persisted view-mode preference once the token becomes available (it may
    // load async) or when it changes (e.g. a settings update). We sync only when the
    // token's stored value actually changes — not merely when it differs from viewMode —
    // so a local user toggle (which doesn't change the context token) is never clobbered.
    const persistedViewMode = tokenSettings?.ecomm_view_mode;
    useEffect(() => {
        if (persistedViewMode && persistedViewMode !== lastAppliedViewMode.current) {
            lastAppliedViewMode.current = persistedViewMode;
            setViewMode(persistedViewMode);
        }
    }, [persistedViewMode]);

    useEffect(() => {
        if (!hasValidAccountSetup) {
            uiContext.setModalCloseOnOverlayClick(false);
            uiContext.setModalCloseOnEsc(false);
            uiContext.setModalComponent(
                <div className="p-4 d-flex flex-column align-items-center text-center" style={{ maxWidth: "40vw" }}>
                    <i className="fas fa-exclamation-triangle text-warning mb-3" style={{ fontSize: "3rem" }} />
                    <OwTitle className="mb-3" title="account_setup_required" tag="h4" />
                    <OwP className="mb-4 text-start" content="account_setup_required_message" />
                    <OwP className="mb-4 text-start" content="account_setup_required_message_2" />
                    <OwButton
                        title="i_understand"
                        className="btn btn-primary"
                        fn={() => {
                            uiContext.showModal(false);
                            uiContext.setModalComponent(null);
                            uiContext.resetModalClassesAndStyles();
                        }}
                    />
                </div>
            );
            uiContext.showModal(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasValidAccountSetup]);

    useEffect(() => {
        if (categoryGuidFromUrl !== selectedCategoryDetail.guid) {
            setSelectedCategoryDetail({ guid: categoryGuidFromUrl || undefined });
        }
    }, [categoryGuidFromUrl]);

    // Keep the facet + price selection in sync with the ?attrs=/?minPrice=/?maxPrice= URL params
    // (back/forward navigation). No-op after applyFacetFilters' own navigate() since state is
    // already updated by then.
    const attrsFromUrl = searchParams.get("attrs");
    const minPriceFromUrl = searchParams.get("minPrice");
    const maxPriceFromUrl = searchParams.get("maxPrice");
    useEffect(() => {
        const parsed = FacetFilterService.parseFacetsFromUrl(attrsFromUrl);
        const parsedPriceRange = FacetFilterService.parsePriceRangeFromParams(searchParams);

        const attrsChanged =
            FacetFilterService.serializeFacetsToUrl(parsed) !== FacetFilterService.serializeFacetsToUrl(selectedAttributeFilters);
        const priceChanged = !FacetFilterService.priceRangesEqual(parsedPriceRange, selectedPriceRange);

        if (attrsChanged || priceChanged) {
            setSelectedAttributeFilters(parsed);
            setSelectedPriceRange(parsedPriceRange);
            setOffset(0);

            if (selectedCategoryDetail.guid && !searchTermFromUrl) {
                // Fresh reference re-fires the category browse effect with the restored filters
                setSelectedCategoryDetail({ guid: selectedCategoryDetail.guid });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attrsFromUrl, minPriceFromUrl, maxPriceFromUrl]);

    useEffect(() => {
        if (!hasValidAccountSetup) {
            return;
        }

        if (socket) {
            for (const _socket of sockets) {
                socket.on(_socket.endpoint, _socket.fn);
            }

            getCategories();

            if (supplierModel.has_home_categories && !categoryGuidFromUrl) {
                getHomeCategories();
            }

            document.title = "Orderwerks >> Home";

            // getTypeaheadCatalogItem(true);
            setupRightSideHeaderComponent();
            refreshCart();
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }

            uiContext.setSubHeaderComponent(null);
        };
    }, [vendorModel.guid]);

    // Update cart item count when cart changes
    useEffect(() => {
        if (cart?.Cart_Items) {
            let count = 0;
            for (const item of cart.Cart_Items) {
                if (!item.parent_cart_item_id) {
                    count++;
                }
            }
            uiContext.setCartItemCount(count);
        }
    }, [cart]);

    const onGetCategories = (data: IOnGetCategoriesDTO) => {
        // Pin enabled virtual categories (New Releases, Ready to Ship) above the real
        // root categories, but never inject them into the home categories list.
        const categories =
            data.onlyRootCategories && !data.isHomeCategories
                ? [...buildVirtualRootCategories(supplierModel), ...data.categories]
                : data.categories;

        if (data.onlyRootCategories) {
            setRootCategories(categories);
        }

        if (data.isHomeCategories) {
            setHomeCategories(categories);
        } else {
            setCategories(categories);
        }

        if (!data.isHomeCategories) {
            setupSearchSubHeader();
            setRetrievedCategories(true);
        }
    };

    const onGetProductsInCategory = (data: IOnGetCategoryCatalogItemsDTO) => {
        setSearchItems(data.catalogItems);
        setIsCategoryLoading(false);
        setIsLoading(false);

        if (data.totalItems) {
            setTotalRecords(data.totalItems);
        }

        // move the user to the top of the page
        document.getElementById("mainView")?.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const onGetTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        // The Quick Order view fetches through the same event; don't let its
        // results clobber the card/list items or pagination.
        if (data.state === "quickOrder") {
            return;
        }

        setSearchItems(data.catalog_items);
        setPerformInitialSearch(true);
        setTotalRecords(data.totalCatalogItems);
        setIsLoading(false);
        // Category browsing with attribute filters is served by the typeahead, so the
        // category-loading flag set when the grid was cleared must be released here too.
        setIsCategoryLoading(false);

        document.getElementById("mainView")?.scroll({ top: 0, left: 0, behavior: "auto" });
        uiContext.setActivityIndicator(isLoading);
    };

    const onGetCatalogItemFacets = (data: IOnGetCatalogItemFacetsDTO) => {
        // Drop stale responses (rapid filter toggles / category switches)
        if (data.state !== String(facetStateRef.current)) {
            return;
        }

        setFacets(data.facets);
    };

    const onAddToCart = (data: IOnAddItemToCartDTO) => {
        refreshCart();

        const isMobile = window.innerWidth < 768; // Bootstrap md breakpoint

        if (isMobile) {
            // On mobile, show bottom sheet notification instead of sidebar
            setMobileCartItem(data.cartItem);
            setShowMobileCartNotification(true);
        } else {
            // On desktop, open sidebar and show toast
            toggleCartSidebar();

            const notification = {
                message: "item_added_to_cart",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.success,
            } as INotification;

            uiContext.notifyFn(null, notification);
        }
    };

    const onUpdateCartItem = (data: IOnUpdateCartItemDTO) => {
        if (data?.cartItem) {
            updateCartItem(data.cartItem);
        } else {
            refreshCart();
        }
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: onGetTypeaheadCatalogItem },
        { endpoint: EndpointsEnum.CatalogItemOnGetCatalogItemFacets, fn: onGetCatalogItemFacets },
        { endpoint: EndpointsEnum.CategoriesOnGetCategoryCatalogItems, fn: onGetProductsInCategory },
        { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: onGetCategories },
        { endpoint: EndpointsEnum.CartOnAddItem, fn: onAddToCart },
        { endpoint: EndpointsEnum.CartOnUpdateItem, fn: onUpdateCartItem },
    ];

    useEffect(() => {
        if (match?.params.itemName) {
            console.log("isItemDetail: ", selectedItem);
        }
    }, [match?.params.itemName]);

    useEffect(() => {
        setupSearchSubHeader();
    }, [categories]);

    useEffect(() => {
        if (retrievedCategories) {
            setupSearchSubHeader();
        }
    }, [cartOpen]);

    useEffect(() => {
        if (retrievedCategories && clearSearchTerm) {
            setupSearchSubHeader();
        }
    }, [clearSearchTerm]);

    /**
     * Anytime the offset or limit are changed, will be the main process for getting the next page
     * This also helps us with preventing double api calls.
     *
     * NOTE: This gets called when the page loads
     */
    useEffect(() => {
        if (skipNextOffsetFetchRef.current) {
            skipNextOffsetFetchRef.current = false;
            return;
        }

        if (!selectedCategoryDetail.guid) {
            getTypeaheadCatalogItem(isCommonItems, selectedCategoryGuid, enteredSearchTerm);
        } else if (filtersActive) {
            // Attribute/price filters route category browse through the typeahead (only path that filters)
            getTypeaheadCatalogItem(false, selectedCategoryDetail.guid, enteredSearchTerm, selectedAttributeFilters, selectedPriceRange);
        } else {
            getProductsInCategory();
        }
    }, [offset, limit]);

    useEffect(() => {
        // Only load category products if we're browsing a category (not searching within one)
        if (selectedCategoryDetail.guid && !searchTermFromUrl) {
            setSearchItems([]);

            if (filtersActive) {
                getTypeaheadCatalogItem(false, selectedCategoryDetail.guid, "", selectedAttributeFilters, selectedPriceRange);
            } else {
                setIsCategoryLoading(true);
                getProductsInHomeCategory();
            }

            getCatalogItemFacets(selectedCategoryDetail.guid, "", selectedAttributeFilters, selectedPriceRange);
        } else if (!selectedCategoryDetail.guid) {
            setFacets([]);
        }
    }, [selectedCategoryDetail, searchTermFromUrl]);

    useEffect(() => {
        // Initialize categoryContext from URL param when root categories are loaded
        if (categoryGuidFromUrl && rootCategories?.length) {
            const categoryFromUrl = rootCategories.find((cat) => cat.guid === categoryGuidFromUrl);
            if (categoryFromUrl && categoryContext.category?.guid !== categoryGuidFromUrl) {
                categoryContext.setFn(categoryFromUrl);
            }
        } else if (!categoryGuidFromUrl && categoryContext.category) {
            // No category in the URL (fresh visit or Home) — clear any selection left in
            // the app-level context by a previous visit/view so the dropdown resets to All.
            categoryContext.setFn(undefined);
        }
    }, [categoryGuidFromUrl, rootCategories]);

    // Handle initial search from URL params - runs once when categories are loaded
    useEffect(() => {
        if (searchTermFromUrl && retrievedCategories && !performedInitialSearch) {
            setIsCommonItems(false);
            getTypeaheadCatalogItem(
                false,
                categoryGuidFromUrl || undefined,
                searchTermFromUrl,
                filtersActive ? selectedAttributeFilters : undefined,
                selectedPriceRange
            );

            if (categoryGuidFromUrl) {
                getCatalogItemFacets(categoryGuidFromUrl, searchTermFromUrl, selectedAttributeFilters, selectedPriceRange);
            }
        }
    }, [searchTermFromUrl, retrievedCategories, performedInitialSearch, categoryGuidFromUrl]);

    const toggleCategorySidebar = () => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const getProductsInCategory = () => {
        if (selectedCategoryDetail) {
            const payload: IGetCategoryCatalogItemsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: vendorModel.guid,
                categoryGuid: selectedCategoryDetail.guid!,
                catalogGuid: vendorModel.Catalog!.guid,
                limit,
                offset,
                includeTotalItems: true,
                includeSubcategories: true,
                excludeProductGroupItems: true,
                excludeHiddenCategoryItems: true,
            };

            setIsCategoryLoading(true);
            socket.emit(EndpointsEnum.CategoriesGetCategoryCatalogItems, payload);
        }
    };

    const getProductsInHomeCategory = () => {
        if (selectedCategoryDetail) {
            const payload: IGetCategoryCatalogItemsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: vendorModel.guid,
                categoryGuid: selectedCategoryDetail.guid!,
                catalogGuid: vendorModel.Catalog!.guid,
                limit: 25,
                offset: 0,
                includeTotalItems: true,
                includeSubcategories: true,
                excludeProductGroupItems: true,
                excludeHiddenCategoryItems: true,
            };

            setIsCategoryLoading(true);
            socket.emit(EndpointsEnum.CategoriesGetCategoryCatalogItems, payload);
        }
    };

    const viewCategory = (category: ICategory) => {
        const currentOffsetZero = offset === 0;

        toggleCategorySidebar();

        setSearchItems([]);
        setIsCategoryLoading(true);
        setIsCommonItems(false);

        setSelectedCategoryGuid(category.guid);

        // Facet selections are category-specific; entering a category starts clean
        setSelectedAttributeFilters({});
        setSelectedPriceRange(null);
        setFacets([]);
        setShowMobileFilters(false);

        setEnteredSearchTerm("");

        if (!currentOffsetZero) {
            // The fresh selectedCategoryDetail reference below is the single fetch trigger for
            // this change; keep the offset reset from also firing a (stale-category) request.
            skipNextOffsetFetchRef.current = true;
            setOffset(0);
        }

        // This callback runs from a sidebar component snapshot stored in uiContext, so
        // any state read here (categoryGuidFromUrl, selectedCategoryDetail) can be stale.
        // Setting a fresh object reference unconditionally re-fires the fetch effect even
        // when the category (and therefore the URL) is unchanged — navigate() alone is a
        // no-op in that case and the skeletons would spin forever.
        setSelectedCategoryDetail({ guid: category.guid });
        navigate(`/ecomm?category=${category.guid}`);

        // move the user to the top of the page
        window.scrollTo(0, 0);
    };

    const toggleCatalogSidebar = () => {
        if (rootCategories) {
            const component = (
                <EcommerceCategorySidebar
                    rootCategories={rootCategories}
                    toggleSidebar={toggleCategorySidebar}
                    viewCategory={viewCategory}
                    hasNoOrder={true}
                />
            );

            uiContext.setSidebarComponent(component);
            uiContext.toggleSidebar(true, { pullRight: false });
        }
    };

    const viewCartMobile = () => {
        proceedToCheckout();
    };

    const toggleCartSidebar = () => {
        setCartOpen(true);
        const cartSidebarComponent = <EcommerceCart socket={socket} />;

        uiContext.setRightSideComponent(cartSidebarComponent);
        uiContext.toggleRightSide(true);
    };

    const cancelSidebar = () => {
        uiContext.setRightSideComponent(null);
        uiContext.toggleRightSide(false);
        setCartOpen(false);
    };

    const deleteCartItem = () => {};

    const updateCartItemStub = () => {};

    const toggleCheckoutView = () => {};

    const performSearch = (searchTerm: string, _selectedCategoryGuid?: string | undefined) => {
        // Searching within the same category keeps the facet/price selection; anything else resets it
        const sameCategory = !!_selectedCategoryGuid && _selectedCategoryGuid === selectedCategoryDetail.guid;
        const keepFilters = sameCategory ? selectedAttributeFilters : {};
        const keepFiltersActive = FacetFilterService.hasActiveFilters(keepFilters);
        const keepPriceRange = sameCategory ? selectedPriceRange : null;

        if (!keepFiltersActive) {
            setSelectedAttributeFilters({});
        }

        if (!FacetFilterService.hasActivePriceRange(keepPriceRange)) {
            setSelectedPriceRange(null);
        }

        getTypeaheadCatalogItem(false, _selectedCategoryGuid, searchTerm, keepFiltersActive ? keepFilters : undefined, keepPriceRange);

        if (_selectedCategoryGuid) {
            getCatalogItemFacets(_selectedCategoryGuid, searchTerm, keepFilters, keepPriceRange);
        } else {
            setFacets([]);
        }

        setEnteredSearchTerm(searchTerm);
        setSelectedCategoryGuid(_selectedCategoryGuid);
        setOffset(0);
        setIsCommonItems(false);

        let search = `?search=${searchTerm}`;

        if (_selectedCategoryGuid) {
            if (searchTerm.length) {
                search += `&`;
            } else {
                search = `?`;
            }

            search += `category=${_selectedCategoryGuid}`;
        }

        if (keepFiltersActive) {
            const serializedFilters = FacetFilterService.serializeFacetsToUrl(keepFilters);
            search += `${search.length > 1 ? "&" : ""}attrs=${serializedFilters}`;
        }

        if (FacetFilterService.hasActivePriceRange(keepPriceRange)) {
            const priceParams = new URLSearchParams();
            FacetFilterService.serializePriceRangeToParams(priceParams, keepPriceRange);
            search += `${search.length > 1 ? "&" : ""}${priceParams.toString()}`;
        }

        // move the user to the top of the page
        window.scrollTo(0, 0);

        navigate({
            pathname: `/ecomm/`,
            search,
        });
    };

    const getCommonItems = () => {
        // Reset all category/search state and load common items
        setSelectedCategoryDetail({});
        setSelectedCategoryGuid(undefined);
        setEnteredSearchTerm("");
        setIsCommonItems(true);
        setOffset(0);
        setSelectedAttributeFilters({});
        setSelectedPriceRange(null);
        setFacets([]);
        setShowMobileFilters(false);
        categoryContext.setFn(undefined);
        getTypeaheadCatalogItem(true, undefined, "");

        // Load home categories if supplier has them
        if (supplierModel.has_home_categories) {
            getHomeCategories();
        }
    };

    const getHomeCategories = () => {
        if (vendorModel.Catalog) {
            const payload: IGetCategoriesDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: vendorModel.Catalog.guid,
                onlyRootCategories: false,
                isHomeCategories: true,
            };

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
        }
    };

    const getCategories = () => {
        if (vendorModel.Catalog) {
            const payload: IGetCategoriesDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                onlyRootCategories: true,
                catalogGuid: vendorModel.Catalog.guid,
            };

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
        }
    };

    const proceedToCheckout = () => {
        uiContext.setRightSideComponent(null);
        uiContext.setRightSideHeaderComponent(null);
        uiContext.toggleRightSide(false);
        navigate("/ecomm/checkout");
    };

    const setupRightSideHeaderComponent = () => {
        const headerComponent = <EcommerceRightSideHeader proceedToCheckout={proceedToCheckout} />;

        uiContext.setRightSideHeaderComponent(headerComponent);
    };

    const setupSearchSubHeader = () => {
        if (categories) {
            const subHeaderComponent = (
                <EcommerceSearchSubHeader
                    lookupLeft={"0"}
                    lookupWidth={"100%"}
                    toggleCatalogSidebar={toggleCatalogSidebar}
                    toggleCartSidebar={toggleCartSidebar}
                    cartOpen={cartOpen}
                    closeCartSidebar={cancelSidebar}
                    isReadOnly={false}
                    performSearch={performSearch}
                    isCheckoutView={false}
                    getCommonItems={getCommonItems}
                    viewCart={viewCartMobile}
                    categories={categories}
                    mainUrl={"/ecomm"}
                    clearSearchTerm={clearSearchTerm}
                    initialSearchTerm={searchTermFromUrl || ""}
                />
            );

            uiContext.setSubHeaderComponent(subHeaderComponent);
        }
    };

    const getCatalogItemFacets = (
        categoryGuid: string,
        searchTerm: string,
        filters: SelectedAttributeFilters,
        priceRange?: IPriceRangeFilter | null
    ) => {
        if (!vendorModel.Catalog || isTemplateRestricted) {
            return;
        }

        facetStateRef.current += 1;

        const payload: IGetCatalogItemFacetsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            catalogGuid: vendorModel.Catalog.guid,
            categoryGuid,
            name: searchTerm || undefined,
            // Same price group the typeahead sends, so counts filter on the price the grid displays
            priceGroupGuid: vendorModel.Price_Group?.guid,
            options: {
                searchName: true,
                searchSku: true,
                searchDescription: true,
                searchUpc: true,
                attributes: FacetFilterService.toAttributeOptions(filters),
                priceRange: FacetFilterService.hasActivePriceRange(priceRange) ? priceRange! : undefined,
            },
            state: String(facetStateRef.current),
            excludeHiddenCategoryItems: true,
        };

        if (!userModel.isSupplierUser) {
            payload.vendorGuid = vendorModel.guid;
        }

        socket.emit(EndpointsEnum.CatalogItemGetCatalogItemFacets, payload);
    };

    /**
     * Applies a new facet selection: resets pagination, syncs the `attrs` URL param, and refetches
     * items + facet counts. Item refetching leans on the existing effects where possible (offset
     * change / fresh selectedCategoryDetail reference) to avoid double fetches with stale state.
     */
    const applyFacetFilters = (next: SelectedAttributeFilters, nextPriceRange: IPriceRangeFilter | null) => {
        if (!selectedCategoryDetail.guid) {
            return;
        }

        const categoryGuid = selectedCategoryDetail.guid;
        const currentOffsetZero = offset === 0;
        const searchActive = !!searchTermFromUrl;

        setSelectedAttributeFilters(next);
        setSelectedPriceRange(nextPriceRange);
        setIsCommonItems(false);
        setOffset(0);

        const params = new URLSearchParams(searchParams);
        const serialized = FacetFilterService.serializeFacetsToUrl(next);

        if (serialized.length) {
            params.set("attrs", serialized);
        } else {
            params.delete("attrs");
        }

        FacetFilterService.serializePriceRangeToParams(params, nextPriceRange);

        navigate({ pathname: "/ecomm", search: `?${params.toString()}` });

        if (currentOffsetZero && !searchActive) {
            // Fresh object reference re-fires the category browse effect (items + facets).
            // Flag the load synchronously so the cleared grid shows skeletons, not "no results".
            setSearchItems([]);
            setIsCategoryLoading(true);
            setSelectedCategoryDetail({ guid: categoryGuid });
            return;
        }

        // Offset reset (or active search) re-fetches items via the offset effect / directly here;
        // facets always need an explicit refresh with the new selection.
        if (currentOffsetZero && searchActive) {
            setSearchItems([]);
            getTypeaheadCatalogItem(false, categoryGuid, enteredSearchTerm, next, nextPriceRange);
        }

        getCatalogItemFacets(categoryGuid, searchActive ? enteredSearchTerm : "", next, nextPriceRange);
    };

    const toggleFacetValue = (name: string, value: string) => {
        applyFacetFilters(FacetFilterService.toggleValue(selectedAttributeFilters, name, value), selectedPriceRange);
    };

    const applyPriceRange = (priceRange: IPriceRangeFilter) => {
        // Submitting with both inputs blank clears the price filter
        applyFacetFilters(selectedAttributeFilters, FacetFilterService.hasActivePriceRange(priceRange) ? priceRange : null);
    };

    const clearFacetFilters = () => {
        applyFacetFilters({}, null);
    };

    const getTypeaheadCatalogItem = (
        isCommonsItems?: boolean,
        categoryGuid?: string,
        searchTerm?: string,
        attributeFilters?: SelectedAttributeFilters,
        priceRange?: IPriceRangeFilter | null
    ) => {
        if (vendorModel.Catalog) {
            const attributes = attributeFilters ? FacetFilterService.toAttributeOptions(attributeFilters) : undefined;
            const priceActive = FacetFilterService.hasActivePriceRange(priceRange);

            const payload: ITypeaheadCatalogItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: vendorModel.Catalog.guid,
                name: searchTerm || enteredSearchTerm,
                limit,
                offset,
                onlyActive: true,
                includeTotal: true,
                includeKitItems: true,
                excludeHiddenCategoryItems: true,
                priceGroupGuid: vendorModel.Price_Group?.guid,
                options: {
                    searchName: true,
                    searchSku: true,
                    searchDescription: true,
                    searchUpc: true,
                    attributes,
                },
            };

            if (priceActive) {
                // Top-level field — the backend reads data.priceRange, not options.priceRange
                payload.priceRange = priceRange!;
            }

            if ((attributes || priceActive) && categoryGuid) {
                // Guid-based scoping works for non-root categories (the categoryId lookup below is root-only)
                payload.categoryGuid = categoryGuid;
                payload.includeSubcategories = true;
            } else if (categoryGuid && rootCategories) {
                const categoryModel = rootCategories.find((cat) => cat.guid === categoryGuid);

                if (categoryModel) {
                    payload.categoryId = categoryModel.id;
                    payload.includeSubcategories = true;
                }
            }

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            if (isCommonsItems) {
                payload.onlyCommonItems = true;
                payload.includeStandardIfNoCommonItems = true;
            }

            socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);

            setIsLoading(true);
            uiContext.setActivityIndicator(isLoading);
        }
    };

    const emitAddToCart = (draftItem: IDraftOrderItem, options?: Parameters<ProcessOrderEntryItemFn>[1]) => {
        const payload: IAddItemToCartDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: vendorModel.guid,
            qty: draftItem.qty,
            catalogItemGuid: draftItem.guid,
        };

        if (options?.uomSet) {
            payload.uomSetId = options.uomSet.id;
        }

        if (options?.discount) {
            payload.discountId = options.discount.id;
        }

        if (options?.kitBuilderOptions) {
            payload.kitBuilderData = options.kitBuilderOptions;
        }

        if (options?.itemOptions) {
            payload.itemOptionValues = options.itemOptions.map((itemOption) => {
                return {
                    item_option_id: itemOption.item_option_id!,
                    value: itemOption.value,
                };
            });
        }

        socket.emit(EndpointsEnum.CartAddItem, payload);
    };

    const emitUpdateCartItemQty = (existingCartItem: ICart_Item, additionalQty: number) => {
        const payload: IUpdateCartItemDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            qty: Number(existingCartItem.qty) + additionalQty,
            cartItemGuid: existingCartItem.guid,
        };

        if (!userModel.isSupplierUser) {
            payload.vendorGuid = vendorModel.guid;
        }

        socket.emit(EndpointsEnum.CartUpdateItem, payload);
    };

    const addToCart: ProcessOrderEntryItemFn = (item, options) => {
        const _item = item as IDraftOrderItem;

        if (cart?.Cart_Items) {
            const existingCartItem = cart.Cart_Items.find((ci) => ci.catalog_item_id === item.id);

            if (existingCartItem) {
                if (supplierModel.no_dupe_order_items) {
                    const notification: INotification = {
                        message: "item_already_in_cart",
                        position: NotificationPositionEnum.bc,
                        level: NotificationLevelEnum.warning,
                    };

                    uiContext.notifyFn(null, notification);
                    return;
                }

                const optionsMatch = OrderEntryService.doItemOptionsMatch(existingCartItem.Cart_Item_Options, options?.itemOptions);

                if (optionsMatch) {
                    const closeModal = (action: DuplicateItemAction) => {
                        uiContext.setModalComponent(null);
                        uiContext.showModal(false);

                        switch (action) {
                            case "update_qty":
                                emitUpdateCartItemQty(existingCartItem, Number(_item.qty));
                                break;
                            case "add_new_line":
                                emitAddToCart(_item, options);
                                break;
                        }
                    };

                    const modalComponent = (
                        <DuplicateItemModal
                            itemName={existingCartItem.Catalog_Item?.name || item.name || ""}
                            existingQty={Number(existingCartItem.qty)}
                            newQty={Number(_item.qty)}
                            closeModalFn={closeModal}
                        />
                    );

                    uiContext.setModalSetup({
                        modalStyle: {
                            overlay: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            },
                            content: {
                                position: "relative",
                                inset: "auto",
                                width: "30rem",
                                maxWidth: "90vw",
                                height: "auto",
                                minHeight: "auto",
                                padding: "1.5rem",
                            },
                        },
                    });
                    uiContext.setModalComponent(modalComponent);
                    uiContext.showModal(true);
                    return;
                }
            }
        }

        emitAddToCart(_item, options);
    };

    const openDetailView = (item: ICatalog_Item) => {
        navigate(`/ecomm/item/${item.name}/${item.guid}`);
        setSelectedItem(item);
    };

    const onPaginationChanged = (selectedOffset: number, selectedLimit: number) => {
        setOffset(selectedOffset);
        setLimit(selectedLimit);

        // move the user to the top of the page
        document.getElementById("mainView")?.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    if (!hasValidAccountSetup) {
        return (
            <EcommerceContainer className={"Ecommerce container-fluid container-md mt-4"}>
                <AccountSetupMessage className="d-flex flex-column align-items-center text-center py-5">
                    <div className="d-flex flex-column align-items-center text-center" style={{ maxWidth: "40vw" }}>
                        <i className="fas fa-exclamation-triangle text-warning mb-3" style={{ fontSize: "3rem" }} />
                        <OwTitle className="mb-3" title="account_setup_required" tag="h4" />
                        <OwP className="mb-4 text-start" content="account_setup_required_message" />
                        <OwP className="mb-4 text-start" content="account_setup_required_message_2" />
                    </div>
                </AccountSetupMessage>
            </EcommerceContainer>
        );
    }

    return (
        <EcommerceContainer className={"Ecommerce container-fluid container-md mt-4"}>
            {match?.params?.itemName && selectedItem ? (
                <EcommerceItemDetailPage item={selectedItem} priceGroupName={vendorModel.Price_Group?.value || ""} socket={socket} />
            ) : (
                <>
                    {supplierModel.Service_Levels?.length && supplierModel.ecomm_show_service_level_header ? (
                        <EcommerceServiceLevels serviceLevels={supplierModel.Service_Levels} />
                    ) : null}

                    {supplierModel.login_message_detail?.title?.length || supplierModel.login_message_detail?.detail?.length ? (
                        <div className={"mb-4"}>
                            <LoginMessage showPreviewBox={false} loginMessageDetail={supplierModel.login_message_detail} />
                        </div>
                    ) : null}

                    {viewMode !== EcommerceViewModeEnum.QUICK ? (
                        <ItemView
                            className={"ecomm-grid " + (homeCategories.length > 0 && offset === 0 && showHomeCategories ? "mb-5" : "")}>
                            {offset === 0 &&
                                showHomeCategories &&
                                homeCategories.map((homeCategory) => {
                                    return <EcommerceHomeCategoryListView category={homeCategory} key={homeCategory.guid} />;
                                })}
                        </ItemView>
                    ) : null}
                    <div className={"ecomm-view-toggle"}>
                        <EcommerceViewToggle viewMode={viewMode} onChange={handleViewModeChange} />
                    </div>
                    {viewMode === EcommerceViewModeEnum.QUICK ? (
                        <EcommerceQuickOrder toggleCartSidebar={toggleCartSidebar} />
                    ) : (
                        <BrowseLayout>
                            {showFacetSidebar ? (
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm d-md-none mb-3"
                                    onClick={() => setShowMobileFilters((prev) => !prev)}>
                                    <i className="fas fa-filter me-2" />
                                    <FormattedMessage id="filters" />
                                    {activeFilterCount ? ` (${activeFilterCount})` : ""}
                                </button>
                            ) : null}

                            <div className="d-md-flex align-items-start">
                                {showFacetSidebar ? (
                                    <FacetColumn className={showMobileFilters ? "mb-3" : "d-none d-md-block"}>
                                        <EcommerceFacetSidebar
                                            facets={facets}
                                            selectedFilters={selectedAttributeFilters}
                                            priceRange={selectedPriceRange}
                                            toggleValue={toggleFacetValue}
                                            onPriceRangeSearch={applyPriceRange}
                                            clearAll={clearFacetFilters}
                                            hidePriceFilter={hidePricing}
                                        />
                                    </FacetColumn>
                                ) : null}

                                <BrowseMain>
                                    <ItemView className={getItemViewClass()}>
                                        {isCategoryLoading || isLoading
                                            ? Array.from({ length: 10 }).map((_, i) => <EcommerceListViewSkeleton key={`skeleton-${i}`} />)
                                            : searchItems.map((item) => {
                                                  return (
                                                      <EcommerceListView
                                                          key={item.guid}
                                                          catalogItem={item}
                                                          priceGroupName={vendorModel.Price_Group?.value || ""}
                                                          addToCart={addToCart}
                                                          openDetailView={openDetailView}
                                                          isReadOnly={false}
                                                          order={
                                                              {
                                                                  Price_Group: vendorModel.Price_Group,
                                                              } as IOrder
                                                          }
                                                          supplierVendorToken={supplierVendorToken}
                                                          socket={socket}
                                                          isCategoryView={!!selectedCategoryGuid}
                                                          viewMode={viewMode}
                                                      />
                                                  );
                                              })}

                                        {!isCategoryLoading &&
                                        !isLoading &&
                                        !searchItems.length &&
                                        (performedInitialSearch || selectedCategoryDetail.guid) ? (
                                            <EcommerceNoResults
                                                searchTerm={enteredSearchTerm}
                                                onClearFilters={() => {
                                                    setEnteredSearchTerm("");
                                                    setOffset(0);
                                                    setClearSearchTerm((prev) => prev + 1);
                                                    setSelectedAttributeFilters({});
                                                    setSelectedPriceRange(null);
                                                    if (selectedCategoryDetail.guid) {
                                                        // Stay on category, reload category products and update URL
                                                        getProductsInCategory();
                                                        getCatalogItemFacets(selectedCategoryDetail.guid, "", {});
                                                        navigate(`/ecomm?category=${selectedCategoryDetail.guid}`);
                                                    } else {
                                                        // No category selected, load common items and clear URL
                                                        setSelectedCategoryGuid(undefined);
                                                        setIsCommonItems(true);
                                                        getTypeaheadCatalogItem(true, undefined, "");
                                                        navigate("/ecomm/");
                                                    }
                                                }}
                                                onBrowseAll={() => {
                                                    setEnteredSearchTerm("");
                                                    setSelectedCategoryGuid(undefined);
                                                    setSelectedCategoryDetail({});
                                                    setIsCommonItems(true);
                                                    setOffset(0);
                                                    setSelectedAttributeFilters({});
                                                    setSelectedPriceRange(null);
                                                    setFacets([]);
                                                    categoryContext.setFn(undefined);
                                                    getTypeaheadCatalogItem(true, undefined, "");
                                                    navigate("/ecomm/");
                                                }}
                                            />
                                        ) : null}
                                    </ItemView>
                                </BrowseMain>
                            </div>
                        </BrowseLayout>
                    )}
                    {viewMode !== EcommerceViewModeEnum.QUICK && searchItems.length && totalRecords ? (
                        <PaginationContainer className={"d-md-flex justify-content-md-center"}>
                            <PaginationBar
                                offset={offset}
                                limit={limit}
                                totalRecords={totalRecords}
                                onPaginationChanged={onPaginationChanged}
                                hideLimit={true}
                            />
                        </PaginationContainer>
                    ) : null}
                </>
            )}

            <MobileCartNotification
                show={showMobileCartNotification}
                cartItem={mobileCartItem}
                onClose={() => setShowMobileCartNotification(false)}
                onViewCart={() => {
                    setShowMobileCartNotification(false);
                    proceedToCheckout();
                }}
            />
        </EcommerceContainer>
    );
};

const EcommerceContainer = styled.div`
    margin-bottom: 5rem;
`;

const BrowseLayout = styled.div``;

const FacetColumn = styled.div`
    @media (min-width: 768px) {
        flex: 0 0 15rem;
        width: 15rem;
        margin-right: 1.5rem;
        position: sticky;
        top: 1rem;
    }
`;

const BrowseMain = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

const ItemView = styled.div`
    //display: flex;
    //width: 100%;
    //margin-bottom: 5rem;
    //flex-wrap: wrap;
`;

const PaginationContainer = styled.div`
    //width: 100%;
    //justify-content: center;
`;

const AccountSetupMessage = styled.div`
    min-height: 50vh;
    justify-content: center;
`;
